import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import { Row } from "reactstrap";
import cx from "classnames";
import { useProjectSummarySidebarContext } from "providers/ProjectSummarySidebarProvider";
import { ProductCard } from "components/ProductsOverview/ProductCard";
import { useAppBaseContext } from "providers";
import { useTranslate } from "hooks";
import {
  useProductsOverviewActions,
  useProductsOverviewStore,
} from "stores/productsOverviewStore";
import { productNavigationHandler } from "utils/productNavigationHandler";
import { useProjectDataStore } from "stores/projectStore";

export const ProductsOverviewBody = Scrivito.connect(
  ({
    error,
    id,
    infoText,
    isModalActive,
    dummy,
    wizardType,
    modal,
    handleBackAction,
    type,
    groupPosition,
  }) => {
    const translate = useTranslate();
    const { isExtended } = useProjectSummarySidebarContext();
    const { isSameProj } = useAppBaseContext();
    const {
      setProductCategoryId,
      navigateToConfiguratorPage,
      navigateToProductListPage,
    } = useProductsOverviewActions();
    const projectId = useProjectDataStore((state) => state.projectId);

    const productsContent = useProductsOverviewStore(
      (state) => state.productsContent,
    );
    const imageCardHandler = useCallback(
      (product) =>
        productNavigationHandler({
          product,
          isModalActive,
          id,
          dummy,
          wizardType,
          handleBackAction,
          type,
          groupPosition,
          modal,
          setProductCategoryId,
          navigateToConfiguratorPage,
          projectId,
          navigateToProductListPage,
        }),
      [
        isModalActive,
        id,
        dummy,
        wizardType,
        handleBackAction,
        type,
        groupPosition,
        modal,
        setProductCategoryId,
        navigateToConfiguratorPage,
        projectId,
        navigateToProductListPage,
      ],
    );

    if (error) {
      return (
        <div className="mb-6">
          <span>{translate("ERROR_OCCURED")}</span>
        </div>
      );
    }

    if (infoText) {
      return (
        <Row className="px-3 pt-6">
          {infoText.split(/\r?\n/g).map((parag, index) => (
            <p className="px-2 font16" key={index}>
              {parag}
            </p>
          ))}
        </Row>
      );
    }

    return (
      <Row
        className={cx("px-5", { "overflow-auto": isModalActive })}
        style={{
          ...(isModalActive && { maxHeight: "60vh" }),
        }}
      >
        {productsContent?.map((product) => (
          <ProductCard
            product={product}
            key={
              product.pimId ? `${product.key}+${product.pimId}` : product.key
            }
            isExtended={isExtended}
            imageCardHandler={imageCardHandler}
            isSameProj={isSameProj}
          />
        ))}
      </Row>
    );
  },
);
